// EXPORT TO EXCEL HELPER FUNCTIONS

import { ToastType } from '~/api/gqlEnums';
import { ExportFormatType } from '~/generated/graphql';
import { setToast } from '~/hooks/useToastParametersLocalQuery';

export const exportDate = new Date().toLocaleDateString().replace(/\//g, '-');
export const makeFilename = (fileNameTokens: string[], format: ExportFormatType) => {
  const formatSuffix = format === ExportFormatType.EXCEL ? 'xlsx' : 'csv';
  const tokens = [...fileNameTokens, `${exportDate}.${formatSuffix}`];
  return tokens.join(' - ');
};

export const getDownloadingMessage = (
  fileNameTokens: string[],
  format: ExportFormatType = ExportFormatType.EXCEL
) => `Exporting: ${makeFilename(fileNameTokens, format)}`;

export const getDownloadedMessage = (
  fileNameTokens: string[],
  format: ExportFormatType = ExportFormatType.EXCEL
) => `Export complete: ${makeFilename(fileNameTokens, format)}`;

export const showExportToast = (message: string) => {
  setToast({ message }, ToastType.DEFAULT, null);
};
